import {sessionData} from './stores.js'
import snsWebSdk from '@sumsub/websdk'
import axios from 'axios'


async function getSumsubAccessToken(){


  let session

  const unsub = sessionData.subscribe (s => session = s)

  const t = await session.user.getIdToken()
  const atok = await axios.get(process.env.BASE_GAMBIT_URL + "kyc/init", {
    headers: {
    'Authorization': `Bearer ${t}`
    }
    });

  unsub()
  return atok.data.token
}



function launchContinue(accessToken) {



    let snsWebSdkInstance = snsWebSdk.init(
            accessToken,
            // token update callback, must return Promise
            // Access token expired
            // get a new one and pass it to the callback to re-initiate the WebSDK
            () => {return new Promise((resolve, reject) => {resolve (accessToken)})}
        )
        .withConf({
            i18n: {}, //JSON of custom SDK Translations
            uiConf: {
                //customCss: "https://url.com/styles.css"
                // URL to css file in case you need change it dynamically from the code
                // the similar setting at Customizations tab will rewrite customCss
                // you may also use to pass string with plain styles `customCssStr:`
            },
        })
        .withOptions({ addViewportTag: false, adaptIframeHeight: true})
        // see below what kind of messages WebSDK generates
        .build();

    // you are ready to go:
    // just launch the WebSDK by providing the container element for it
    snsWebSdkInstance.launch('#sumsub-websdk-continue')
}




function launchWebSdk(accessToken) {



    let snsWebSdkInstance = snsWebSdk.init(
            accessToken,
            // token update callback, must return Promise
            // Access token expired
            // get a new one and pass it to the callback to re-initiate the WebSDK
            () => getSumsubAccessToken()
        )
        .withConf({
            // lang: 'en', //language of WebSDK texts and comments (ISO 639-1 format)
            // email: "oskar@goo.d",
            // phone: "+46745562774",
            i18n: {}, //JSON of custom SDK Translations
            uiConf: {
                customCss: "https://url.com/styles.css"
                // URL to css file in case you need change it dynamically from the code
                // the similar setting at Customizations tab will rewrite customCss
                // you may also use to pass string with plain styles `customCssStr:`
            },
        })
        .withOptions({ addViewportTag: false, adaptIframeHeight: true})
        // see below what kind of messages WebSDK generates
        .on('idCheck.onApplicantSubmitted', (payload) => {




          setTimeout(() => {
            sessionData.update(s => ({...s, sumsubHidden: true, sumsubApplication: {...s.sumsubApplication, reviewStatus: 'pending'}, sumsubContinue: false, localSumsubApproval: null}) )
          }, 1000)




        })
        .on('idCheck.onError', (error) => {
            console.error('onError SUMSUB', error)
        })
        .on('idCheck.applicantStatus', (payload) => {
          sessionData.update(s => ({...s, sumsubApplication: payload}) )

        })
        .build();

    // you are ready to go:
    // just launch the WebSDK by providing the container element for it
    snsWebSdkInstance.launch('#sumsub-websdk-container')
}

async function launchSumsub (){
  const tok = await getSumsubAccessToken()
  launchWebSdk(tok)
}


export {getSumsubAccessToken, launchWebSdk, launchSumsub, launchContinue}
